import { X } from "lucide-react";
import formatCurrency from "../../utils/formatCurrency";

import ModalWrapper from "../Modal";

const ViewTransactionModal = ({ isOpen, onClose, transaction }) => {
  if (!transaction) return null;

  // Determine icon and status color
  let iconSrc = "/images/icons/transaction-success.svg";
  let iconAlt = "transaction success";
  let statusBg = "bg-[#E7F6EC]";
  let statusDot = "bg-[#27A341]";
  let statusText = "text-[#27A341]";
  if (transaction.status === "pending") {
    iconSrc = "/images/icons/transaction-pending.svg";
    iconAlt = "transaction pending";
    statusBg = "bg-orange-100";
    statusDot = "bg-orange-500";
    statusText = "text-orange-600";
  } else if (transaction.status === "failed") {
    iconSrc = "/images/icons/transaction-failed.svg";
    iconAlt = "transaction failed";
    statusBg = "bg-red-100";
    statusDot = "bg-red-500";
    statusText = "text-red-600";
  }

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose} size="medium">
      <div className="relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-2 right-2 text-[#4F535D] hover:text-gray-600 transition-colors"
        >
          <X size={24} />
        </button>

        {/* Header: Success Icon and Large Amount */}
        <div className="mt-4 mb-8 flex flex-col items-center gap-4">
          {/* Header Icon */}
          <div className="mt-[22px] mb-6 flex justify-center">
            <img src={iconSrc} alt={iconAlt} className="h-16 w-16" />
          </div>
          <h1 className="text-2xl font-semibold text-[#0C0C0E]">
            {formatCurrency(transaction?.amount || 0)}
          </h1>
        </div>

        {/* Transaction Details Card */}
        <div className="mb-6 w-auto sm:min-w-[370px] rounded-lg px-6 py-6 bg-[#F8F7F9]">
          <div className="mb-4 flex justify-between items-center">
            <span className="text-[#7D828D] text-base font-medium">
              Transaction Ref
            </span>
            <span className="text-[#0C0C0E] font-semibold text-base truncate max-w-[200px]">
              {transaction.tnx_ref}
            </span>
          </div>

          <div className="mb-4 flex justify-between items-center">
            <span className="text-[#7D828D] text-base font-medium">
              Order ID
            </span>
            <span className="text-[#0C0C0E] font-semibold text-base">
              ORD-{transaction.order_id}
            </span>
          </div>

          <div className="mb-4 flex justify-between items-center">
            <span className="text-[#7D828D] text-base font-medium">
              Customer
            </span>
            <span className="text-[#0C0C0E] font-semibold text-base">
              {transaction.user?.name}
            </span>
          </div>

          <div className="mb-4 flex justify-between items-center">
            <span className="text-[#7D828D] text-base font-medium">Amount</span>
            <span className="text-[#0C0C0E] font-semibold text-base">
              {formatCurrency(transaction?.amount || 0)}
            </span>
          </div>

          <div className="mb-4 flex justify-between items-center">
            <span className="text-[#7D828D] text-base font-medium">Method</span>
            <div className="flex items-center gap-2">
              <div className="w-6 h-4 bg-[#00C3F7] rounded-sm flex flex-col justify-center gap-[2px] px-[2px]">
                <div className="h-[2px] bg-white w-full"></div>
                <div className="h-[2px] bg-white w-full"></div>
              </div>
              <span className="text-[#0C0C0E] font-semibold text-base">
                Paystack
              </span>
            </div>
          </div>

          <div className="mb-4 flex justify-between items-center">
            <span className="text-[#7D828D] text-base font-medium">Status</span>
            <div
              className={`flex items-center gap-1.5 ${statusBg} px-3 py-1 rounded-full`}
            >
              <div className={`w-2 h-2 rounded-full ${statusDot}`}></div>
              <span
                className={`${statusText} font-semibold text-sm capitalize`}
              >
                {transaction.status || "nil"}
              </span>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <span className="text-[#7D828D] text-base font-medium">Date</span>
            <span className="text-[#0C0C0E] font-semibold text-base">
              {transaction.created_at
                ? new Date(transaction.created_at)
                    .toLocaleString("en-GB", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                    .replace(",", "")
                : "N/A"}
            </span>
          </div>
        </div>

        {/* Action Button */}
        <div className="w-full">
          <button
            onClick={onClose}
            className="w-full rounded-2xl h-12 border border-[#ECEDEF] bg-white text-base font-semibold text-[#0C0C0E] transition-all hover:bg-gray-50 active:scale-[0.98]"
          >
            Close
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ViewTransactionModal;
